exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag_new[data-v-6d5fdfe7] {\n  background: #3a8ee6;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 46px;\n  padding: 10px 0 10px 0;\n  text-align: center;\n  color: #fff;\n  font-size: 14px;\n  text-transform: capitalize;\n  z-index: 1;\n  line-height: 16px;\n}\n.tag_new[data-v-6d5fdfe7]::after {\n    content: \"\";\n    position: absolute;\n    bottom: -8px;\n    left: 0;\n    border-style: solid;\n    border-width: 0 23px 8px;\n    border-color: transparent #3a8ee6 transparent #3a8ee6;\n}\n", ""]);

// exports
